<div class="flex h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-start justify-between px-6" [ngClass]="shortScreen ? 'pt-3' : 'pt-6'">
    <div>
      <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.SHIP_TO_MODAL.TITLE' | t }}</h2>
      @if (!shortScreen) {
      <p class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.SHIP_TO_MODAL.SUBTITLE' | t }}</p>
      }
    </div>
    <button mat-icon-button type="button" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- search + filtros -->
  <div class="flex flex-col gap-3 px-6" [ngClass]="shortScreen ? 'py-2' : 'py-4'">
    <div class="flex items-center gap-3">
      <div class="flex flex-1 items-center gap-3 rounded-xl border px-4 py-2">
        <mat-icon class="text-secondary">search</mat-icon>
        <input class="w-full min-w-0 flex-1 bg-transparent outline-none" type="text"
          [placeholder]="'DOCUMENT_GENERATE.SHIP_TO_MODAL.SEARCH_PLACEHOLDER' | t" [(ngModel)]="search"
          (keyup.enter)="onSearchEnter()" autofocus>
      </div>
      <!-- con poca altura los filtros se guardan tras este botón para dejar ver los resultados -->
      @if (shortScreen) {
      <button mat-stroked-button type="button" class="shrink-0" (click)="showFilters = !showFilters">
        <mat-icon>filter_list</mat-icon>
        {{ 'DOCUMENT_GENERATE.ACTIONS.FILTERS' | t }}@if (activeFilterCount) {<span>&nbsp;({{ activeFilterCount }})</span>}
      </button>
      }
    </div>
    <div class="flex flex-col gap-3 sm:flex-row" [class.hidden]="shortScreen && !showFilters">
      <mat-form-field class="w-full sm:w-1/3" subscriptSizing="dynamic">
        <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.SALES_OFFICE' | t }}</mat-label>
        <input matInput [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.ALL_FEMININE' | t"
          [matAutocomplete]="autoOffice" [(ngModel)]="officeSearch"
          (ngModelChange)="onOfficeInput()">
        @if (officeSearch) {
        <button matSuffix mat-icon-button type="button" (click)="officeSearch = ''; onOfficeInput()">
          <mat-icon>close</mat-icon>
        </button>
        }
        <mat-autocomplete #autoOffice="matAutocomplete" (optionSelected)="onOfficeSelected($event.option.value)">
          @for (o of filteredOffices; track o._id) {
          <mat-option [value]="o.name">{{ o.name }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="w-full sm:w-1/3" subscriptSizing="dynamic">
        <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.DEPARTMENT' | t }}</mat-label>
        <input matInput [placeholder]="'GENERAL.ALL' | t"
          [matAutocomplete]="autoDepartment" [(ngModel)]="departmentSearch"
          (ngModelChange)="onDepartmentInput()">
        @if (departmentSearch) {
        <button matSuffix mat-icon-button type="button" (click)="departmentSearch = ''; onDepartmentInput()">
          <mat-icon>close</mat-icon>
        </button>
        }
        <mat-autocomplete #autoDepartment="matAutocomplete" (optionSelected)="onDepartmentSelected($event.option.value)">
          @for (department of filteredDepartments; track department) {
          <mat-option [value]="department">{{ department }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="w-full sm:w-1/3" subscriptSizing="dynamic">
        <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.TERRITORY' | t }}</mat-label>
        <input matInput [placeholder]="'GENERAL.ALL' | t"
          [matAutocomplete]="autoRoute" [(ngModel)]="routeSearch"
          (ngModelChange)="onRouteInput()">
        @if (routeSearch) {
        <button matSuffix mat-icon-button type="button" (click)="routeSearch = ''; onRouteInput()">
          <mat-icon>close</mat-icon>
        </button>
        }
        <mat-autocomplete #autoRoute="matAutocomplete" (optionSelected)="onRouteSelected($event.option.value)">
          @for (r of filteredRoutes; track r._id) {
          <mat-option [value]="r.name">{{ r.name }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>

  <!-- results, móvil: tarjetas -->
  <div #cardsScroll class="min-h-0 flex-1 overflow-auto border-t p-3 md:hidden">
    <div class="flex flex-col gap-3">
      @for (s of results; track s._id) {
      <div class="flex cursor-pointer flex-col rounded-xl border bg-card p-3"
        [class.border-primary]="isSelected(s)" [class.bg-primary-50]="isSelected(s)"
        [class.dark:bg-primary-900]="isSelected(s)" (click)="select(s)">
        <div class="flex items-start gap-2">
          <mat-checkbox class="-ml-2" [checked]="isSelected(s)" (change)="select(s)"
            (click)="$event.stopPropagation()"></mat-checkbox>
          <div class="flex min-w-0 flex-1 flex-col">
            <span class="text-primary font-semibold">{{ code(s) }}</span>
            <span class="text-sm font-medium uppercase">{{ s.name }}</span>
          </div>
        </div>

        <div class="mt-3 flex flex-col gap-2 border-t pt-3 text-sm">
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.COLUMNS.DEPARTMENT' | t }}</span>
            <span class="text-right">{{ department(s) }}</span>
          </div>
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.COLUMNS.TERRITORY' | t }}</span>
            <span class="text-right">{{ route(s) }}</span>
          </div>
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.COLUMNS.SALES_OFFICE' | t }}</span>
            <span class="text-right">{{ office(s) }}</span>
          </div>
        </div>
      </div>
      } @empty {
      <div class="text-secondary flex h-40 items-center justify-center px-4 text-center text-sm">
        {{ 'DOCUMENT_GENERATE.SHIP_TO_MODAL.NO_RESULTS' | t }}
      </div>
      }
    </div>
  </div>

  <!-- results, desktop/tablet: tabla -->
  <div #resultsScroll class="hidden min-h-0 flex-1 overflow-auto border-t md:block">
    <table class="w-full min-w-[720px] border-collapse text-base">
      <thead class="sticky top-0 z-10 bg-gray-50 dark:bg-gray-800">
        <tr class="text-secondary text-left">
          <th class="px-4 py-3"></th>
          <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.SHIP_TO' | t }}</th>
          <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.DEPARTMENT' | t }}</th>
          <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.TERRITORY' | t }}</th>
          <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.SALES_OFFICE' | t }}</th>
        </tr>
      </thead>
      <tbody>
        @for (s of results; track s._id) {
        <tr class="cursor-pointer border-t hover:bg-gray-50 dark:hover:bg-gray-800/40"
          [class.bg-primary-50]="isSelected(s)" [class.dark:bg-primary-900]="isSelected(s)" (click)="select(s)">
          <td class="px-4 py-3">
            <mat-checkbox [checked]="isSelected(s)" (change)="select(s)" (click)="$event.stopPropagation()"></mat-checkbox>
          </td>
          <td class="px-4 py-3">
            <div class="flex flex-col">
              <span class="text-primary font-semibold">{{ code(s) }}</span>
              <span class="font-medium uppercase">{{ s.name }}</span>
            </div>
          </td>
          <td class="px-4 py-3">{{ department(s) }}</td>
          <td class="px-4 py-3">
            <span class="inline-block max-w-[160px] truncate align-middle" [matTooltip]="route(s)">{{ route(s) }}</span>
          </td>
          <td class="px-4 py-3">{{ office(s) }}</td>
        </tr>
        } @empty {
        <tr>
          <td colspan="5">
            <div class="text-secondary flex h-40 items-center justify-center text-sm">
              {{ 'DOCUMENT_GENERATE.SHIP_TO_MODAL.EMPTY' | t }}
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- footer -->
  <div class="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 border-t px-6"
    [ngClass]="shortScreen ? 'py-2' : 'py-4'">
    <span class="text-secondary text-sm"
      [innerHTML]="'DOCUMENT_GENERATE.SHIP_TO_MODAL.RESULTS_COUNT' | t: { count: results.length }"></span>
    <div class="flex items-center gap-1">
      <button mat-icon-button type="button" [matTooltip]="'DOCUMENT_GENERATE.PAGINATION.PREVIOUS' | t" [disabled]="page <= 1 || loading"
        (click)="changePage(-1)">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <span class="text-secondary whitespace-nowrap text-sm">{{ page }} / {{ totalPages }}</span>
      <button mat-icon-button type="button" [matTooltip]="'DOCUMENT_GENERATE.PAGINATION.NEXT' | t" [disabled]="page >= totalPages || loading"
        (click)="changePage(1)">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
    <div class="flex gap-3">
      <button mat-stroked-button type="button" (click)="cancel()">{{ 'GENERAL.CANCEL' | t }}</button>
      <button mat-flat-button color="primary" type="button" [disabled]="!selectedId" (click)="confirm()">
        {{ 'DOCUMENT_GENERATE.SHIP_TO_MODAL.SELECT' | t }}
      </button>
    </div>
  </div>
</div>
